import React from 'react';
import { Row, Col } from 'reactstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("footer", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, currentYear, " \xA9 Hyper - Coderthemes.com"), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md-right footer-links d-none d-md-block"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, "About"), /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, "Support"), /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, "Contact Us")))))));
};

export default Footer;